<template>
  <div class="Introduction">
    <h1 style="font-weight: bold; letter-spacing: 3px; border: 0;font-size: 31vw">VINK</h1>

    <h3>Elke dag twee nieuwe gedichten</h3>
    <p>Elke dag krijg je twee nieuwe gedichten. Vers gevangen, nieuw talent, gecureerd door Nederlandse
      uitgeverijen.</p>

    <h3>Geef een gedicht cadeau</h3>
    <p>Ontdek samen poëzie. Iedere lezer heeft wekelijks een unieke verzameling gedichten.
      hoe: Elke gedicht leeft maximaal zeven dagen online. Geef ze door zolang ze leven.</p>

    <router-link to="/">Ga door naar de app</router-link>

  </div>
</template>

<script>
  export default {
    name: 'Introduction'
  }
</script>

<style>
  .Introduction {
    background-color: #fff;
    height: 100vh;
    padding: 2em;
  }

  .Introduction .VueCarousel {
    margin-top: 4em;
    text-align: center;
  }

  .Introduction a {
    padding: 0.5em 1em;
    border: 1px solid currentColor;
    color: currentColor;
    text-decoration: none;
    margin-top: 2em;
    display: inline-block;
    font-family: "stevie-sans", sans-serif;
  }
</style>



// WEBPACK FOOTER //
// src/components/Introduction.vue